/**
 * ATTENTION! This file is auto-generated for the 'mailer' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { EmailAccountRepository } from '../server/repositories/EmailAccountRepository';
import type { EmailAttachmentRepository } from '../server/repositories/EmailAttachmentRepository';
import type { IncomingEmailRepository } from '../server/repositories/IncomingEmailRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","meta","getInstance","columns","filters"];

type EmailAccountRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<EmailAccountRepository>;
export function useEmailAccountRepository(): EmailAccountRepositoryClient { return makeRepositoryProxy<EmailAccountRepositoryClient>('mailer::EmailAccountRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useEmailAccountRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const emailAccountRepository = useEmailAccountRepository();

type EmailAttachmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<EmailAttachmentRepository>;
export function useEmailAttachmentRepository(): EmailAttachmentRepositoryClient { return makeRepositoryProxy<EmailAttachmentRepositoryClient>('mailer::EmailAttachmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useEmailAttachmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const emailAttachmentRepository = useEmailAttachmentRepository();

type IncomingEmailRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<IncomingEmailRepository>;
export function useIncomingEmailRepository(): IncomingEmailRepositoryClient { return makeRepositoryProxy<IncomingEmailRepositoryClient>('mailer::IncomingEmailRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useIncomingEmailRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const incomingEmailRepository = useIncomingEmailRepository();

type testImapConnectionType = typeof import('../server/functions/testImapConnection').testImapConnection;
export const testImapConnection: RpcFunctionClient<testImapConnectionType> = makeFunctionProxy<testImapConnectionType>('mailer::testImapConnection');
